import * as translations from '../messages';
export class Translator {
    constructor() {
        this.translationsMap = {};
        this.loadTranslations();
    }
    getTranslation(locale, id, defaultMessage, variables) {
        const translationMap = this.translationsMap[locale];
        let translation;
        if (translationMap) {
            translation = translationMap[id];
        }
        let message = (translation || defaultMessage);
        if (variables) {
            Object.keys(variables).forEach((variable) => {
                message = message.replace('{{' + variable + '}}', variables[variable]);
            });
        }
        return message;
    }
    loadTranslations() {
        const t = translations;
        Object.keys(translations).forEach((locale) => {
            this.translationsMap[locale] = t[locale];
        });
    }
}
